module.exports = __webpack_public_path__ + "static/kommune-hero-img-14432dd2aaaf4cc51d44904ff5afceee.png";